module.exports = __webpack_public_path__ + "media/init/static/fonts/GT-Eesti-Pro-Display-Regular-668a7b63a6cd311b99ba4425b45d00e7.OTF";